import { useCallback } from 'react';

import useGoogleIdentityServiceGet from './useGoogleIdentityServiceGet';

interface ButtonParams {
  type: 'standard' | 'icon';
  theme: 'outline' | 'filled_blue' | 'filled_black';
  size: 'small' | 'medium' | 'large';
  shape: 'rectangular' | 'pill' | 'circle' | 'square';
  text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
  width?: number;
}

interface Props {
  onSubmit: (response) => void;
}

export default (props: Props) => {
  const gis = useGoogleIdentityServiceGet({ ...props });

  const renderButton = useCallback(
    (ref: HTMLDivElement | null, params: ButtonParams) => {
      if (gis && ref) {
        gis.renderButton(ref, { width: 280, text: 'signin_with', ...params });
      }
    },
    [gis],
  );

  return renderButton;
};
